export const getHomeBannerList = state => state.home.bannerList;
export const getHomeRegularClassLessonList = state =>
  state.home.regularClass.lessonList;
export const getHomeRegularClassInstructorList = state =>
  state.home.regularClass.instructorList;
const getHomeCourseById = id => state => state.home.course.courseList.byId[id];
export const getHomeCourseList = state =>
  state.home.course.courseList.allIds.map(id => getHomeCourseById(id)(state));
export const getAcademyPostList = state => state.home.academy.postList;
